import { api } from '@cma/app'
import {
  CreateCustomPageMutation,
  CreateCustomPageMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useCreateCustomPage() {
  const queryClient = useQueryClient()
  return useMutation<
    CreateCustomPageMutation,
    Error,
    CreateCustomPageMutationVariables
  >(
    ({ input }) => {
      const query = gql`
        mutation CreateCustomPage($input: CustomPageInput!) {
          createCustomPage(input: $input) {
            customPage {
              key
            }
            errors
          }
        }
      `
      const variables = { input }
      return api<CreateCustomPageMutation>({ query, variables })
    },
    {
      async onSuccess() {
        await queryClient.invalidateQueries(['customPages'])
      }
    }
  )
}
